export default function EmployeeSelector({ employees, selected, onChange, disabledIds = [] }) {
  const toggle = (id) => {
    if (disabledIds.includes(id)) return;
    onChange(
      selected.includes(id)
        ? selected.filter((e) => e !== id)
        : [...selected, id]
    );
  };

  return (
    <div className="flex flex-wrap gap-2">
      {employees.map((e) => {
        const active = selected.includes(e.id);
        const disabled = disabledIds.includes(e.id);
        const label = e.fullName || e.name || e.label || e.username || "Unnamed";

        return (
          <button
            key={e.id}
            onClick={() => toggle(e.id)}
            className={`px-3 py-1 rounded-full text-sm border ${
              active ? "bg-blue-600 text-white" : "bg-gray-100"
            } ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
            disabled={disabled}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
